import React, { useState, useEffect } from "react";
import { Input, Label, ComboBox, ComboBoxItem, FlexBox, FlexBoxDirection, Button } from "@ui5/webcomponents-react";
import localforage from 'localforage';
import { toolOptions, bilangPunoAniUnit } from '../models/selectionConstants.js'

const SocioeconomicForm6 = ({ formData, onFormChange, handlePrevious, handleNext }) => {
  const [agriculturalLandEntries, setAgriculturalLandEntries] = useState(formData.cultivatedLand || []);
  const [agriculturalProductsEntries, setAgriculturalProductsEntries] = useState(formData.agriculturalProducts || []);
  const [machineryEntries, setMachineryEntries] = useState(formData.agriculturalMachineries || []);
  const [animalsRaisedEntries, setAnimalsRaisedEntries] = useState(formData.animalsRaised || []);
  const [petAnimalsEntries, setPetAnimalsEntries] = useState(formData.petAnimals || []);
  const [fisheriesEntries, setFisheriesEntries] = useState(formData.fisheriesEntries || []);

  const [provinces, setProvinces] = useState([]);

  const animalsForFood = [
    { number: 1, description: "1 - Pig (Baboy)" },
    { number: 2, description: "2 - Chicken-Chick(young)" },
    { number: 3, description: "3 - Cattle-Cow(female)" },
    { number: 4, description: "4 - Carabao" },
    { number: 5, description: "5 - Goat-Buck(Male)" },
    { number: 6, description: "6 - Horse-Stallion(Male)" },
    { number: 7, description: "7 - Pabo (Turkey)" },
    { number: 8, description: "8 - Duck-Drake(Male)" },
    { number: 9, description: "9 - Pugo (Quail)" },
    { number: 10, description: "10 - Duck-Duck(female)" },
    { number: 17, description: "17 - Kabir" },
    { number: 18, description: "18 - Palakang Bukid" },
    { number: 19, description: "19 - Swan" },
    { number: 20, description: "20 - Gansa (Goose)" },
    { number: 21, description: "21 - Saso" },
    { number: 22, description: "22 - Manok (Native)" },
    { number: 23, description: "23 - Deer (Usa)" },
    { number: 24, description: "24 - Native Goat" },
    { number: 25, description: "25 - Boar-Boar(Male)" },
    { number: 26, description: "26 - Sheep-Buck(Male)" },
    { number: 27, description: "27 - Others" },
    { number: 28, description: "28 - F1 Carabao" },
    { number: 29, description: "29 - Baka, Native" },
    { number: 30, description: "30 - Hog-Boar(Male)" },
    { number: 31, description: "31 - Hog-Sow(female)" },
    { number: 32, description: "32 - Hog-Farrow(young)" },
    { number: 33, description: "33 - Hog-Shoat(young)" },
    { number: 35, description: "35 - Manok (sasabungin)" },
    { number: 36, description: "36 - Chicken-Hen(female)" },
    { number: 37, description: "37 - Chicken-Cockerel (rooster)(young)" },
    { number: 38, description: "38 - Bangala" },
    { number: 39, description: "39 - Ostrich" },
    { number: 40, description: "40 - Boar-Piglet(young)" },
    { number: 41, description: "41 - Boar-Sow(female)" },
    { number: 42, description: "42 - Cattle-Bull(Male)" },
    { number: 43, description: "43 - Cattle-Calf(young)" },
    { number: 44, description: "44 - Chicken-Pullet (hen)(young)" },
    { number: 45, description: "45 - Chicken-Rooster(Male)" },
    { number: 46, description: "46 - Deer-(female)" },
    { number: 47, description: "47 - Deer-(young)" },
    { number: 48, description: "48 - Deer-Buck(Male)" },
    { number: 49, description: "49 - Deer-Doe(female)" },
    { number: 50, description: "50 - Deer-Fawn(young)" },
    { number: 51, description: "51 - Deer-Stag(Male)" },
    { number: 52, description: "52 - Duck-Duckling(young)" },
    { number: 53, description: "53 - Duck-Hen(female)" },
    { number: 54, description: "54 - Goat-(female)" },
    { number: 55, description: "55 - Goat-(young)" },
    { number: 56, description: "56 - Goat-Billy(Male)" },
    { number: 57, description: "57 - Goat-Kid(young)" },
    { number: 58, description: "58 - Goat-Nanny(female)" },
    { number: 59, description: "59 - Goose-Gander(female)" },
    { number: 60, description: "60 - Goose-Gander(Male)" },
    { number: 61, description: "61 - Goose-Goose(female)" },
    { number: 62, description: "62 - Goose-Goose(Male)" },
    { number: 63, description: "63 - Goose-Gosling(young)" },
    { number: 64, description: "64 - Guinea Pig-Boar(Male)" },
    { number: 65, description: "65 - Guinea Pig-Pup(young)" },
    { number: 66, description: "66 - Guinea Pig-Sow(female)" },
    { number: 67, description: "67 - Horse-Colt (Male)(young)" },
    { number: 68, description: "68 - Horse-Dam(female)" },
    { number: 69, description: "69 - Horse-Filly (Female)(young)" },
    { number: 70, description: "70 - Horse-Foal(young)" },
    { number: 71, description: "71 - Horse-Mare(female)" },
    { number: 72, description: "72 - Horse-Stud(Male)" },
    { number: 73, description: "73 - Ostrich-Chick(young)" },
    { number: 74, description: "74 - Ostrich-Cock(Male)" },
    { number: 75, description: "75 - Ostrich-Hen(female)" },
    { number: 76, description: "76 - Ox-Bull(Male)" },
    { number: 77, description: "77 - Ox-Calf(young)" },
    { number: 78, description: "78 - Ox-Cow(female)" },
    { number: 79, description: "79 - Pig-Boar(Male)" },
    { number: 80, description: "80 - Pig-Piglet(young)" },
    { number: 81, description: "81 - Pig-Sow(female)" },
    { number: 82, description: "82 - Sheep-(female)" },
    { number: 83, description: "83 - Sheep-(young)" },
    { number: 84, description: "84 - Sheep-Ewe(female)" },
    { number: 85, description: "85 - Sheep-Lamb(young)" },
    { number: 86, description: "86 - Sheep-Ram(Male)" },
    { number: 87, description: "87 - Swan-Cob(Male)" },
    { number: 88, description: "88 - Swan-Cygnet(young)" },
    { number: 89, description: "89 - Swan-Pen(female)" },
    { number: 90, description: "90 - Swine-Boar(Male)" },
    { number: 91, description: "91 - Swine-Piglet(young)" },
    { number: 92, description: "92 - Swine-Sow(female)" },
  ];

  const animalsForPets = [
    { number: 1, description: "1 - Dog (Aso)" },
    { number: 2, description: "2 - Cat (Pusa)" },
    { number: 3, description: "3 - Bird (Ibon)" },
    { number: 4, description: "4 - Monkey" },
    { number: 5, description: "5 - Rabbit" },
    { number: 6, description: "6 - Aquarium fish" },
    { number: 7, description: "7 - Snake (Ahas)" },
    { number: 8, description: "8 - Turtle (Pagong)" },
    { number: 9, description: "9 - Pigeon" },
    { number: 10, description: "10 - Iguana" },
    { number: 11, description: "11 - Hamster" },
    { number: 12, description: "12 - Guinea Pig" },
    { number: 13, description: "13 - Spider" },
    { number: 14, description: "14 - Other reptiles and amphibians" },
    { number: 15, description: "15 - Other" },
    { number: 16, description: "16 - Saltwater fish" },
    { number: 17, description: "17 - Other small animals" },
  ];

  const fisheriesOptions = [
    { value: 1, label: "1 - Carp" },
    { value: 2, label: "2 - Catfish" },
    { value: 3, label: "3 - Falcata" },
    { value: 4, label: "4 - Freshwater catfish (Kanduli)" },
    { value: 5, label: "5 - Freshwater goby (Biya)" },
    { value: 6, label: "6 - Freshwater Shrimp" },
    { value: 7, label: "7 - Gourami" },
    { value: 8, label: "8 - Milkfish" },
    { value: 9, label: "9 - Mudcrab" },
    { value: 10, label: "10 - Mudfish" },
    { value: 11, label: "11 - Mussel" },
    { value: 12, label: "12 - Other crustaceans" },
    { value: 13, label: "13 - Other fish species" },
    { value: 14, label: "14 - Other mollusks" },
    { value: 15, label: "15 - Others" },
    { value: 16, label: "16 - Oyster" },
    { value: 17, label: "17 - Prawn" },
    { value: 18, label: "18 - Seaweed" },
    { value: 19, label: "19 - Tilapia" },
  ];

  const fishpondOwnershipOptions = [
    { value: 1, label: "1 - Titulado" },
    { value: 2, label: "2 - Umuupa" },
    { value: 3, label: "3 - Tenant" },
    { value: 4, label: "4 - Fish Leasehold Agreement (FLA)" },
  ];

  const waterTypeOptions = [
    { value: 1, label: "1 - Alat (Marine)" },
    { value: 2, label: "2 - Tabsing (Brackish)" },
    { value: 3, label: "3 - Tabang (Fresh)" },
    { value: 4, label: "4 - Backyard" },
  ];

  const fishpondTypeOptions = [
    { value: 1, label: "1 - Fish Cage" },
    { value: 2, label: "2 - Fish Pond" },
  ];

  useEffect(() => {
    fetchProvinces();
  }, []);

  useEffect(() => {
    onFormChange("cultivatedLand", agriculturalLandEntries);
  }, [agriculturalLandEntries, onFormChange]);

  useEffect(() => {
    onFormChange("agriculturalProducts", agriculturalProductsEntries);
  }, [agriculturalProductsEntries, onFormChange]);

  useEffect(() => {
    onFormChange("agriculturalMachineries", machineryEntries);
  }, [machineryEntries, onFormChange]);

  useEffect(() => {
    onFormChange("animalsRaised", animalsRaisedEntries);
  }, [animalsRaisedEntries, onFormChange]);

  useEffect(() => {
    onFormChange("petAnimals", petAnimalsEntries);
  }, [petAnimalsEntries, onFormChange]);

  useEffect(() => {
    onFormChange("fisheriesEntries", fisheriesEntries);
  }, [fisheriesEntries, onFormChange]);

  const fetchProvinces = async () => {
    const cacheProvinceKey = 'location_province';
    try {
      const data = await localforage.getItem(cacheProvinceKey);
      setProvinces(data.data);
    } catch (error) {
      console.error("Failed to fetch provinces:", error);
    }
  };

  const fetchMunicipalities = async (provinceId, index) => {
    const cacheMunicipalityKey = 'location_municipality';
    try {
      const data = await localforage.getItem(cacheMunicipalityKey);
      const filteredData = Array.isArray(data.data)
      ? data.data.find(item => item.province_id === Number(provinceId))?.municipalities
      : [];
      setAgriculturalLandEntries((prev) =>
        prev.map((entry, i) =>
          i === index ? { ...entry, municipalities: filteredData, barangays: [] } : entry
        )
      );
    } catch (error) {
      console.error("Failed to fetch municipalities:", error);
    }
  };

  const fetchBarangays = async (municipalityId, index) => {
    const cacheBarangayKey = 'location_barangay';
    try {
      const data = await localforage.getItem(cacheBarangayKey);
      const filteredData = Array.isArray(data.data)
      ? data.data.find(item => item.municipality_id === Number(municipalityId))?.barangays
      : [];
      setAgriculturalLandEntries((prev) =>
        prev.map((entry, i) =>
          i === index ? { ...entry, barangays: filteredData } : entry
        )
      );
    } catch (error) {
      console.error("Failed to fetch barangays:", error);
    }
  };

  const fetchMunicipalitiesForProducts = async (provinceId, index) => {
    const cacheMunicipalityKey = 'location_municipality';
    try {
      const data = await localforage.getItem(cacheMunicipalityKey);
      const filteredData = Array.isArray(data.data)
      ? data.data.find(item => item.province_id === Number(provinceId))?.municipalities
      : [];
      setAgriculturalProductsEntries((prev) =>
        prev.map((entry, i) =>
          i === index ? { ...entry, municipalities: filteredData, barangays: [] } : entry
        )
      );
    } catch (error) {
      console.error("Failed to fetch municipalities:", error);
    }
  };

  const fetchBarangaysForProducts = async (municipalityId, index) => {
    const cacheBarangayKey = 'location_barangay';
    try {
      const data = await localforage.getItem(cacheBarangayKey);
      const filteredData = Array.isArray(data.data)
      ? data.data.find(item => item.municipality_id === Number(municipalityId))?.barangays
      : [];
      setAgriculturalProductsEntries((prev) =>
        prev.map((entry, i) =>
          i === index ? { ...entry, barangays: filteredData } : entry
        )
      );
    } catch (error) {
      console.error("Failed to fetch barangays:", error);
    }
  };

  const fetchMunicipalitiesForFisheries = async (provinceId, index) => {
    const cacheMunicipalityKey = 'location_municipality';
    try {
      const data = await localforage.getItem(cacheMunicipalityKey);
      const filteredData = Array.isArray(data.data)
      ? data.data.find(item => item.province_id === Number(provinceId))?.municipalities
      : [];
      setFisheriesEntries((prev) =>
        prev.map((entry, i) =>
          i === index ? { ...entry, municipalities: filteredData, barangays: [] } : entry
        )
      );
    } catch (error) {
      console.error("Failed to fetch municipalities:", error);
    }
  };

  const fetchBarangaysForFisheries = async (municipalityId, index) => {
    const cacheBarangayKey = 'location_barangay';
    try {
      const data = await localforage.getItem(cacheBarangayKey);
      const filteredData = Array.isArray(data.data)
      ? data.data.find(item => item.municipality_id === Number(municipalityId))?.barangays
      : [];
      setFisheriesEntries((prev) =>
        prev.map((entry, i) =>
          i === index ? { ...entry, barangays: filteredData } : entry
        )
      );
    } catch (error) {
      console.error("Failed to fetch barangays:", error);
    }
  };

  const landOwnershipOptions = [
    { value: 1, label: "1 - Leased" },
    { value: 2, label: "2 - Owned" },
    { value: 3, label: "3 - Tenant" },
    { value: 4, label: "4 - CARP Beneficiary" },
    { value: 5, label: "5 - Farm out/subcontract" },
    { value: 6, label: "6 - Government-owned with consent to farm" },
    { value: 7, label: "7 - Government-owned without consent to farm" },
    { value: 8, label: "8 - Sania" },
    { value: 9, label: "9 - Family-owned" },
    { value: 10, label: "10 - Others, specify:" },
  ];

  const landTypeOptions = [
    { value: 1, label: "1 - Lowland/Irrigated (Shallow Tube Well - STW)" },
    { value: 2, label: "2 - Lowland/Rainfed" },
    { value: 3, label: "3 - Lowland/Irrigated (NIA)" },
    { value: 4, label: "4 - Lowland/Irrigated (Small Farm Reservoir - SFR)" },
    { value: 5, label: "5 - Upland/Irrigated (Shallow Tube Well)" },
    { value: 6, label: "6 - Upland/Rainfed" },
    { value: 7, label: "7 - Upland/Irrigated (NIA)" },
    { value: 8, label: "8 - Upland/Irrigated (Small Farm Reservoir - SFR)" },
    { value: 9, label: "9 - Mangrove Forest" },
  ];

  const productOptions = [
    { value: 1, label: "1 - Palay" },
    { value: 2, label: "2 - Mais" },
    { value: 3, label: "3 - Ampalaya" },
    { value: 4, label: "4 - Cabbage" },
    { value: 5, label: "5 - Camote tops" },
    { value: 6, label: "6 - Carrots" },
    { value: 7, label: "7 - Talong" },
    { value: 8, label: "8 - Bawang" },
    { value: 9, label: "9 - Luya" },
    { value: 10, label: "10 - Patola" },
    { value: 11, label: "11 - Habitchuelas" },
    { value: 12, label: "12 - Mongo" },
    { value: 13, label: "13 - Sibuyas" },
    { value: 14, label: "14 - Mani" },
    { value: 15, label: "15 - Pechay" },
    { value: 16, label: "16 - Patatas" },
    { value: 17, label: "17 - Kalabasa" },
    { value: 18, label: "18 - Stringbeans" },
    { value: 19, label: "19 - Kamatis" },
    { value: 20, label: "20 - Camote" },
    { value: 21, label: "21 - Cassava" },
    { value: 22, label: "22 - Gabi" },
    { value: 23, label: "23 - Saging" },
    { value: 24, label: "24 - Calamansi" },
    { value: 25, label: "25 - Manga" },
    { value: 26, label: "26 - Papaya" },
    { value: 27, label: "27 - Pinya" },
    { value: 28, label: "28 - Watermelon" },
    { value: 29, label: "29 - Abaca" },
    { value: 30, label: "30 - Coconut" },
    { value: 31, label: "31 - Coffee" },
    { value: 32, label: "32 - Rubber" },
    { value: 33, label: "33 - Sugarcane" },
    { value: 34, label: "34 - Tobacco" },
    { value: 35, label: "35 - at iba pa" },
  ];

  

  const areaUnits = [
    { value: 'hectares', label: 'Hectares', factor: 1 },
    { value: 'sqm', label: 'Square Meters', factor: 0.0001 },
  ];

  const handleAddEntry = (setEntries, type) => {
    if (type === 'agriculturalLand') {
      setEntries((prev) => [...prev, { municipalities: [], barangays: [], lawakUnit: 'hectares' }]);
    } else if (type === 'fisheries') {
      setEntries((prev) => [...prev, { municipalities: [], barangays: [] }]);
    } else {
      setEntries((prev) => [...prev, {}]);
    }
  };

  const handleDeleteEntry = (setEntries, index) => {
    setEntries((prev) => prev.filter((_, i) => i !== index));
  };

  const handleInputChange = (setEntries, index, field, value) => {
    setEntries((prev) =>
      prev.map((entry, i) =>
        i === index ? { ...entry, [field]: value } : entry
      )
    );
  };

  const handleAddProductEntry = () => {
    setAgriculturalProductsEntries((prev) => [
      ...prev,
      {
        municipalities: [],
        barangays: [],
        unit: 'hectares',
        areaInput: '',
        ektarya: 0,
        bilangPuno: 0,
        punoAniUnit: 'Puno'
      },
    ]);
  };

  const handleDeleteProductEntry = (index) => {
    setAgriculturalProductsEntries((prev) => prev.filter((_, i) => i !== index));
  };

  const handleProductInputChange = (index, field, value) => {
    setAgriculturalProductsEntries((prev) =>
      prev.map((entry, i) => {
        if (i === index) {
          const updatedEntry = { ...entry, [field]: value };

          if (field === 'areaInput' || field === 'unit') {
            const areaValue = parseFloat(updatedEntry.areaInput) || 0;
            const selectedUnit = areaUnits.find(u => u.value === updatedEntry.unit) || areaUnits[0];
            updatedEntry.ektarya = areaValue * selectedUnit.factor;
          }
          if (field === 'bilangPuno') {
             updatedEntry.bilangPuno = parseInt(value, 10) || 0;
          }

          return updatedEntry;
        }
        return entry;
      })
    );
  };

  return (
    <div style={{ padding: "2rem", maxWidth: "1200px", margin: "auto" }}>
      <h2>Step 6: Agricultural Information</h2>

      {/* D1. Sinasakang Lupa */}
      <h3>D1. Sinasakang Lupa</h3>
      {agriculturalLandEntries.map((entry, index) => (
        <FlexBox key={index} direction={FlexBoxDirection.Column} style={{ gap: "0.5rem", marginBottom: '1rem' }}>
          
          <FlexBox direction={FlexBoxDirection.Row} style={{ gap: "1rem", alignItems: "flex-end"}}>
            <div>
              <Label>Entry {index + 1}:</Label>
              <Label>Lawak</Label>
              <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                <Button
                  design="Transparent"
                  onClick={() => handleInputChange(setAgriculturalLandEntries, index, "lawak", Math.max(0, (entry.lawak || 0) - 1))}
                  style={{ fontSize: "0.9rem", padding: "0.25rem 0.5rem", border: "1px solid #ccc", borderRadius: "4px" }}
                >
                  -
                </Button>
                <Input
                  type="text"
                  inputMode='decimal'
                  value={entry.lawak}
                  onInput={e => {
                    const rawValue = e.target.value ?? ""; // handle null/undefined
                    const val = String(rawValue).replace(/[^0-9.]/g, ""); // ensure it's a string
                    handleInputChange(setAgriculturalLandEntries, index, "lawak", val === "" ? "" : Number(val));
                  }}
                  style={{ width: "9rem", textAlign: "center", textTransform: "uppercase" }}
                />
                <Button
                  design="Transparent"
                  onClick={() => handleInputChange(setAgriculturalLandEntries, index, "lawak",  (entry.lawak || 0) + 1 )}
                  style={{ fontSize: "0.9rem", padding: "0.25rem 0.5rem", border: "1px solid #ccc", borderRadius: "4px" }}
                >
                  +
                </Button>
              </div>
            </div>
            <div style={{ flexBasis: "150px" }}>
              <Label>Unit</Label>
              <select
                value={entry.lawakUnit || 'hectares'}
                onChange={(e) => {
                  const newUnit = e.target.value;
                  let newLawak = entry.lawak;
                  if (entry.lawakUnit === "sqm" && newUnit === "hectares") {
                    newLawak = parseFloat((entry.lawak * 0.0001).toFixed(6)); // sqm to hectares
                  } else if (entry.lawakUnit === "hectares" && newUnit === "sqm") {
                    newLawak = parseFloat((entry.lawak * 10000).toFixed(2)); // hectares to sqm
                  }


                  handleInputChange(setAgriculturalLandEntries, index, "lawak", newLawak);
                  handleInputChange(setAgriculturalLandEntries, index, "lawakUnit", newUnit);
                }}
                style={{
                  width: "100%",
                  height: "2.5rem",
                  padding: "0 0.75rem",
                  border: "1px solid var(--sapField_BorderColor, #89919a)",
                  borderRadius: "var(--sapField_BorderCornerRadius, 0.25rem)",
                  backgroundColor: "var(--sapField_Background, #fff)",
                  color: "var(--sapField_TextColor, #32363a)",
                  fontSize: "var(--sapFontSize, .875rem)",
                  boxSizing: "border-box",
                  appearance: "none",
                  backgroundImage: "var(--sapSelect_IconURL, url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path fill=\"%2332363a\" d=\"M4.4 6.5l3.6 3.6 3.6-3.6.7.7-4.3 4.3-4.3-4.3z\"/></svg>'))",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right 0.75rem center",
                  backgroundSize: "0.75rem",
                }}
              >
                {areaUnits.map(unit => (
                  <option key={unit.value} value={unit.value}>
                    {unit.label}
                  </option>
                ))}
              </select>
            </div>
          </FlexBox>
          
          
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "1rem" }}>
            <div>
              <Label>Province</Label>
              <select
                value={entry.province || ""}
                onChange={(e) => {
                  const provinceId = e.target.value;
                  handleInputChange(setAgriculturalLandEntries, index, "province", provinceId);
                  handleInputChange(setAgriculturalLandEntries, index, "municipality", "");
                  handleInputChange(setAgriculturalLandEntries, index, "barangay", "");
                  fetchMunicipalities(provinceId, index);
                }}
                style={{ width: "100%", padding: "0.5rem" }}
              >
                <option value="">Select Province</option>
                {Array.isArray(provinces) && provinces.length > 0 && provinces.map((province) => (
                  <option key={province.province_id} value={province.province_id}>
                    {province.province_name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <Label>City/Municipality</Label>
              <select
                value={entry.municipality || ""}
                onChange={(e) => {
                  const municipalityId = e.target.value;
                  handleInputChange(setAgriculturalLandEntries, index, "municipality", municipalityId);
                  handleInputChange(setAgriculturalLandEntries, index, "barangay", "");
                  fetchBarangays(municipalityId, index);
                }}
                disabled={!entry.province}
                style={{ width: "100%", padding: "0.5rem" }}
              >
                <option value="">{entry.municipalityName || "Select City/Municipality"}</option>
                {(entry.municipalities || []).map((municipality) => (
                  <option key={municipality.municipality_id} value={municipality.municipality_id}>
                    {municipality.municipality_name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <Label>Barangay</Label>
              <select
                value={entry.barangay || ""}
                onChange={(e) => handleInputChange(setAgriculturalLandEntries, index, "barangay", e.target.value)}
                disabled={!entry.municipality}
                style={{ width: "100%", padding: "0.5rem" }}
              >
                <option value="">{entry.barangayName || "Select Barangay"}</option>
                {(entry.barangays || []).map((barangay) => (
                  <option key={barangay.barangay_id} value={barangay.barangay_id}>
                    {barangay.barangay_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <Label>Kalagayan sa Pag-aari ng Lupang Sinasaka</Label>
          <ComboBox
            value={landOwnershipOptions.find(option => option.value === entry.kalagayan)?.label || ""}
            onChange={(e) => {
              const selectedValue = landOwnershipOptions.find(option => option.label === e.target.value)?.value || null;
              handleInputChange(setAgriculturalLandEntries, index, "kalagayan", selectedValue);
            }}
            style={{ width: "100%", marginBottom: "1rem" }}
          >
            {landOwnershipOptions.map(option => (
              <ComboBoxItem key={option.value} text={option.label} />
            ))}
          </ComboBox>
          <Input
            placeholder="Kung Tenant, sino ang may-ari ng Lupa?"
            value={entry.mayAri || ""}
            onInput={(e) => handleInputChange(setAgriculturalLandEntries, index, "mayAri", e.target.value.toUpperCase())}
            style={{ textTransform: "uppercase" }}
          />
          <Button design="Negative" onClick={() => handleDeleteEntry(setAgriculturalLandEntries, index)}>
            Delete Entry
          </Button>
        </FlexBox>
      ))}
      <Button design="Emphasized" onClick={() => handleAddEntry(setAgriculturalLandEntries, 'agriculturalLand')}>
        Add Entry
      </Button>

      {/* D2. Agricultural Products */}
      <h3>D2. Agricultural Products</h3>
      {agriculturalProductsEntries.map((entry, index) => (
        <FlexBox key={index} direction={FlexBoxDirection.Column} style={{ gap: "0.5rem", marginBottom: "1rem" }}>
          <Label>Entry {index + 1}</Label>
          <Label>Pananim/Produkto</Label>
          <ComboBox
            value={productOptions.find(option => option.value === entry.pananim)?.label || ""}
            onChange={(e) => {
              const selectedValue = productOptions.find(option => option.label === e.target.value)?.value || null;
              handleProductInputChange(index, "pananim", selectedValue);
            }}
            style={{ width: "100%", marginBottom: "1rem" }}
          >
            {productOptions.map(option => (
              <ComboBoxItem key={option.value} text={option.label} />
            ))}
          </ComboBox>
          <Label>Uri ng Lupang Sinasaka</Label>
          <ComboBox
            value={landTypeOptions.find(option => option.value === entry.uriLupa)?.label || ""}
            onChange={(e) => {
              const selectedValue = landTypeOptions.find(option => option.label === e.target.value)?.value || null;
              handleProductInputChange(index, "uriLupa", selectedValue);
            }}
            style={{ width: "100%", marginBottom: "1rem" }}
          >
            {landTypeOptions.map(option => (
              <ComboBoxItem key={option.value} text={option.label} />
            ))}
          </ComboBox>

          <FlexBox direction={FlexBoxDirection.Row} style={{ gap: "1rem", alignItems: "flex-end", marginBottom: "1rem" }}>
            <div style={{ flexGrow: 1 }}>
              <Label>Area</Label>
              <Input
                type="Number"
                placeholder="Enter area"
                value={entry.areaInput || ""}
                onInput={(e) => handleProductInputChange(index, "areaInput", e.target.value.toUpperCase())}
                style={{ width: "100%", textTransform: "uppercase" }}
              />
            </div>
            <div style={{ flexBasis: "150px" }}>
              <Label>Unit</Label>
              <select
                value={entry.unit || 'hectares'}
                onChange={(e) => handleProductInputChange(index, "unit", e.target.value)}
                style={{
                  width: "100%",
                  height: "2.5rem",
                  padding: "0 0.75rem",
                  border: "1px solid var(--sapField_BorderColor, #89919a)",
                  borderRadius: "var(--sapField_BorderCornerRadius, 0.25rem)",
                  backgroundColor: "var(--sapField_Background, #fff)",
                  color: "var(--sapField_TextColor, #32363a)",
                  fontSize: "var(--sapFontSize, .875rem)",
                  boxSizing: "border-box",
                  appearance: "none",
                  backgroundImage: "var(--sapSelect_IconURL, url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path fill=\"%2332363a\" d=\"M4.4 6.5l3.6 3.6 3.6-3.6.7.7-4.3 4.3-4.3-4.3z\"/></svg>'))",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right 0.75rem center",
                  backgroundSize: "0.75rem",
                }}
              >
                {areaUnits.map(unit => (
                  <option key={unit.value} value={unit.value}>
                    {unit.label}
                  </option>
                ))}
              </select>
            </div>
            <div style={{ flexBasis: "150px" }}>
              <Label>Bilang ng Puno/Ani</Label>
              <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                <Button
                  design="Transparent"
                  onClick={() => handleProductInputChange(index, "bilangPuno", Math.max(0, (entry.bilangPuno || 0) - 1))}
                  style={{ fontSize: "0.9rem", padding: "0.25rem 0.5rem", border: "1px solid #ccc", borderRadius: "4px", minWidth: "2rem", height: "2.5rem" }}
                >
                  -
                </Button>
                <Input
                  type="Number"
                  value={entry.bilangPuno || ""}
                  onInput={e => {
                    const val = e.target.value.replace(/[^0-9]/g, "");
                    handleProductInputChange(index, "bilangPuno", val === "" ? "" : Number(val));
                  }}
                  style={{ width: "4rem", textAlign: "center", textTransform: "uppercase" }}
                />
                <Button
                  design="Transparent"
                  onClick={() => handleProductInputChange(index, "bilangPuno", (entry.bilangPuno || 0) + 1)}
                  style={{ fontSize: "0.9rem", padding: "0.25rem 0.5rem", border: "1px solid #ccc", borderRadius: "4px", minWidth: "2rem", height: "2.5rem" }}
                >
                  +
                </Button>
              </div>
            </div>
            <div style={{ flexBasis: "150px" }}>
              <Label>Unit</Label>
              <select
                value={entry.punoAniUnit || 'Puno'}
                onChange={(e) => handleProductInputChange(index, "punoAniUnit", e.target.value)}
                style={{
                  width: "100%",
                  height: "2.5rem",
                  padding: "0 0.75rem",
                  border: "1px solid var(--sapField_BorderColor, #89919a)",
                  borderRadius: "var(--sapField_BorderCornerRadius, 0.25rem)",
                  backgroundColor: "var(--sapField_Background, #fff)",
                  color: "var(--sapField_TextColor, #32363a)",
                  fontSize: "var(--sapFontSize, .875rem)",
                  boxSizing: "border-box",
                  appearance: "none",
                  backgroundImage: "var(--sapSelect_IconURL, url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path fill=\"%2332363a\" d=\"M4.4 6.5l3.6 3.6 3.6-3.6.7.7-4.3 4.3-4.3-4.3z\"/></svg>'))",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "right 0.75rem center",
                  backgroundSize: "0.75rem",
                }}
              >
                {bilangPunoAniUnit.map(unit => ( 
                  <option key={unit.value} value={unit.value}>
                    {unit.label}
                  </option>
                ))}
              </select>
            </div>
          </FlexBox>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "1rem" }}>
            <div>
              <Label>Province</Label>
              <select
                value={entry.province || ""}
                onChange={(e) => {
                  const provinceId = e.target.value;
                  handleProductInputChange(index, "province", provinceId);
                  handleProductInputChange(index, "municipality", "");
                  handleProductInputChange(index, "barangay", "");
                  fetchMunicipalitiesForProducts(provinceId, index);
                }}
                style={{ width: "100%", padding: "0.5rem" }}
              >
                <option value="">Select Province</option>
                {provinces.map((province) => (
                  <option key={province.province_id} value={province.province_id}>
                    {province.province_name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <Label>City/Municipality</Label>
              <select
                value={entry.municipality || ""}
                onChange={(e) => {
                  const municipalityId = e.target.value;
                  handleProductInputChange(index, "municipality", municipalityId);
                  handleProductInputChange(index, "barangay", "");
                  fetchBarangaysForProducts(municipalityId, index);
                }}
                disabled={!entry.province}
                style={{ width: "100%", padding: "0.5rem" }}
              >
                <option value="">{entry.municipalityName || "Select City/Municipality"}</option>
                {(entry.municipalities || []).map((municipality) => (
                  <option key={municipality.municipality_id} value={municipality.municipality_id}>
                    {municipality.municipality_name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <Label>Barangay</Label>
              <select
                value={entry.barangay || ""}
                onChange={(e) => handleProductInputChange(index, "barangay", e.target.value)}
                disabled={!entry.municipality}
                style={{ width: "100%", padding: "0.5rem" }}
              >
                <option value="">{entry.barangayName || "Select Barangay"}</option>
                {(entry.barangays || []).map((barangay) => (
                  <option key={barangay.barangay_id} value={barangay.barangay_id}>
                    {barangay.barangay_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <Button design="Negative" onClick={() => handleDeleteProductEntry(index)}>
            Delete Entry
          </Button>
        </FlexBox>
      ))}
      <Button design="Emphasized" onClick={handleAddProductEntry}>
        Add Entry
      </Button>

      {/* D3. Agricultural Machineries, Equipment and Tools */}
      <h3>D3. Agricultural Machineries, Equipment and Tools</h3>
      {machineryEntries.map((entry, index) => (
        <FlexBox key={index} direction={FlexBoxDirection.Column} style={{ gap: "0.5rem", marginBottom: "1rem" }}>
          <Label>Entry {index + 1}</Label>
          <Label>Tool</Label>
          <ComboBox
            value={toolOptions.find(option => option.value === entry.tool)?.label || ""}
            onChange={(e) => {
              const selectedValue = toolOptions.find(option => option.label === e.target.value)?.value || null;
              handleInputChange(setMachineryEntries, index, "tool", selectedValue);
            }}
            style={{ width: "100%", marginBottom: "1rem" }}
          >
            {toolOptions.map(option => (
              <ComboBoxItem key={option.value} text={option.label} />
            ))}
          </ComboBox>
          <Label>Quantity</Label>
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <Button
              design="Transparent"
              onClick={() => handleInputChange(setMachineryEntries, index, "quantity", Math.max(0, (entry.quantity || 0) - 1))}
              style={{ fontSize: "0.9rem", padding: "0.25rem 0.5rem", border: "1px solid #ccc", borderRadius: "4px" }}
            >
              -
            </Button>
            <Input
              type="Number"
              value={entry.quantity || ""}
              onInput={e => {
                const val = e.target.value.replace(/[^0-9]/g, "");
                handleInputChange(setMachineryEntries, index, "quantity", val === "" ? "" : Number(val));
              }}
              style={{ width: "4rem", textAlign: "center", textTransform: "uppercase" }}
            />
            <Button
              design="Transparent"
              onClick={() => handleInputChange(setMachineryEntries, index, "quantity", (entry.quantity || 0) + 1)}
              style={{ fontSize: "0.9rem", padding: "0.25rem 0.5rem", border: "1px solid #ccc", borderRadius: "4px" }}
            >
              +
            </Button>
          </div>
          <Button design="Negative" onClick={() => handleDeleteEntry(setMachineryEntries, index)}>
            Delete Entry
          </Button>
        </FlexBox>
      ))}
      <Button design="Emphasized" onClick={() => handleAddEntry(setMachineryEntries)}>
        Add Entry
      </Button>

      {/* D4. Animals Raised for Food */}
      <h3>D4. Animals Raised for Food</h3>
      {animalsRaisedEntries.map((entry, index) => (
        <FlexBox key={index} direction={FlexBoxDirection.Column} style={{ gap: "0.5rem", marginBottom: "1rem" }}>
          <Label>Entry {index + 1}</Label>
          <Label>Animal</Label>
          <ComboBox
            value={animalsForFood.find((animal) => animal.number === entry.animal)?.description || ""}
            onChange={(e) => {
              const selectedAnimal = animalsForFood.find((animal) => animal.description === e.target.value);
              handleInputChange(setAnimalsRaisedEntries, index, "animal", selectedAnimal?.number || null);
            }}
            style={{ width: "100%", marginBottom: "1rem" }}
          >
            {animalsForFood.map((animal) => (
              <ComboBoxItem key={animal.number} text={animal.description} />
            ))}
          </ComboBox>
          <Label>Bilang</Label>
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <Button
              design="Transparent"
              onClick={() => handleInputChange(setAnimalsRaisedEntries, index, "bilang", Math.max(0, (entry.bilang || 0) - 1))}
              style={{ fontSize: "0.9rem", padding: "0.25rem 0.5rem", border: "1px solid #ccc", borderRadius: "4px" }}
            >
              -
            </Button>
            <Input
              type="Number"
              value={entry.bilang || ""}
              onInput={e => {
                const val = e.target.value.replace(/[^0-9]/g, "");
                handleInputChange(setAnimalsRaisedEntries, index, "bilang", val === "" ? "" : Number(val));
              }}
              style={{ width: "4rem", textAlign: "center", textTransform: "uppercase" }}
            />
            <Button
              design="Transparent"
              onClick={() => handleInputChange(setAnimalsRaisedEntries, index, "bilang", (entry.bilang || 0) + 1)}
              style={{ fontSize: "0.9rem", padding: "0.25rem 0.5rem", border: "1px solid #ccc", borderRadius: "4px" }}
            >
              +
            </Button>
          </div>
          <Button design="Negative" onClick={() => handleDeleteEntry(setAnimalsRaisedEntries, index)}>
            Delete Entry
          </Button>
        </FlexBox>
      ))}
      <Button design="Emphasized" onClick={() => handleAddEntry(setAnimalsRaisedEntries)}>
        Add Entry
      </Button>

      {/* D5. Pet Animals */}
      <h3>D5. Pet Animals</h3>
      {petAnimalsEntries.map((entry, index) => (
        <FlexBox key={index} direction={FlexBoxDirection.Column} style={{ gap: "0.5rem", marginBottom: "1rem" }}>
          <Label>Entry {index + 1}</Label>
          <Label>Animal</Label>
          <ComboBox
            value={animalsForPets.find((animal) => animal.number === entry.animal)?.description || ""}
            onChange={(e) => {
              const selectedAnimal = animalsForPets.find((animal) => animal.description === e.target.value);
              handleInputChange(setPetAnimalsEntries, index, "animal", selectedAnimal?.number || null);
            }}
            style={{ width: "100%", marginBottom: "1rem" }}
          >
            {animalsForPets.map((animal) => (
              <ComboBoxItem key={animal.number} text={animal.description} />
            ))}
          </ComboBox>
          <Label>Bilang</Label>
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <Button
              design="Transparent"
              onClick={() => handleInputChange(setPetAnimalsEntries, index, "bilang", Math.max(0, (entry.bilang || 0) - 1))}
              style={{ fontSize: "0.9rem", padding: "0.25rem 0.5rem", border: "1px solid #ccc", borderRadius: "4px" }}
            >
              -
            </Button>
            <Input
              type="Number"
              value={entry.bilang || ""}
              onInput={e => {
                const val = e.target.value.replace(/[^0-9]/g, "");
                handleInputChange(setPetAnimalsEntries, index, "bilang", val === "" ? "" : Number(val));
              }}
              style={{ width: "4rem", textAlign: "center", textTransform: "uppercase" }}
            />
            <Button
              design="Transparent"
              onClick={() => handleInputChange(setPetAnimalsEntries, index, "bilang", (entry.bilang || 0) + 1)}
              style={{ fontSize: "0.9rem", padding: "0.25rem 0.5rem", border: "1px solid #ccc", borderRadius: "4px" }}
            >
              +
            </Button>
          </div>
          <Button design="Negative" onClick={() => handleDeleteEntry(setPetAnimalsEntries, index)}>
            Delete Entry
          </Button>
        </FlexBox>
      ))}
      <Button design="Emphasized" onClick={() => handleAddEntry(setPetAnimalsEntries)}>
        Add Entry
      </Button>

      {/* D6. Fisheries Information */}
      <h3>D6. Fisheries Information</h3>
      {fisheriesEntries.map((entry, index) => (
        <FlexBox key={index} direction={FlexBoxDirection.Column} style={{ gap: "0.5rem", marginBottom: "1rem" }}>
          <Label>Entry {index + 1}</Label>
          <Label>Uri ng Inaalagaan sa Palaisdaan</Label>
          <ComboBox
            value={fisheriesOptions.find(option => option.value === entry.uri)?.label || ""}
            onChange={(e) => {
              const selectedValue = fisheriesOptions.find(option => option.label === e.target.value)?.value || null;
              handleInputChange(setFisheriesEntries, index, "uri", selectedValue);
            }}
            style={{ width: "100%", marginBottom: "1rem" }}
          >
            {fisheriesOptions.map(option => (
              <ComboBoxItem key={option.value} text={option.label} />
            ))}
          </ComboBox>
          <Label>Bilang ng Inaalagaan Bawat Taon</Label>
          <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <Button
              design="Transparent"
              onClick={() => handleInputChange(setFisheriesEntries, index, "quantity", Math.max(0, (entry.quantity || 0) - 1))}
              style={{ fontSize: "0.9rem", padding: "0.25rem 0.5rem", border: "1px solid #ccc", borderRadius: "4px" }}
            >
              -
            </Button>
            <Input
              type="Number"
              value={entry.quantity || ""}
              onInput={e => {
                const val = e.target.value.replace(/[^0-9]/g, "");
                handleInputChange(setFisheriesEntries, index, "quantity", val === "" ? "" : Number(val));
              }}
              style={{ width: "4rem", textAlign: "center", textTransform: "uppercase" }}
            />
            <Button
              design="Transparent"
              onClick={() => handleInputChange(setFisheriesEntries, index, "quantity", (entry.quantity || 0) + 1)}
              style={{ fontSize: "0.9rem", padding: "0.25rem 0.5rem", border: "1px solid #ccc", borderRadius: "4px" }}
            >
              +
            </Button>
          </div>
          <Label>Kalagayan ng Palaisdaan</Label>
          <ComboBox
            value={fishpondOwnershipOptions.find(option => option.value === entry.kalagayan)?.label || ""}
            onChange={(e) => {
              const selectedValue = fishpondOwnershipOptions.find(option => option.label === e.target.value)?.value || null;
              handleInputChange(setFisheriesEntries, index, "kalagayan", selectedValue);
            }}
            style={{ width: "100%", marginBottom: "1rem" }}
          >
            {fishpondOwnershipOptions.map(option => (
              <ComboBoxItem key={option.value} text={option.label} />
            ))}
          </ComboBox>
          <Label>Uri ng Tubig sa Palaisdaan</Label>
          <ComboBox
            value={waterTypeOptions.find(option => option.value === entry.waterType)?.label || ""}
            onChange={(e) => {
              const selectedValue = waterTypeOptions.find(option => option.label === e.target.value)?.value || null;
              handleInputChange(setFisheriesEntries, index, "waterType", selectedValue);
            }}
            style={{ width: "100%", marginBottom: "1rem" }}
          >
            {waterTypeOptions.map(option => (
              <ComboBoxItem key={option.value} text={option.label} />
            ))}
          </ComboBox>
          <Label>Uri ng Palaisdaan</Label>
          <ComboBox
            value={fishpondTypeOptions.find(option => option.value === entry.fishpondType)?.label || ""}
            onChange={(e) => {
              const selectedValue = fishpondTypeOptions.find(option => option.label === e.target.value)?.value || null;
              handleInputChange(setFisheriesEntries, index, "fishpondType", selectedValue);
            }}
            style={{ width: "100%", marginBottom: "1rem" }}
          >
            {fishpondTypeOptions.map(option => (
              <ComboBoxItem key={option.value} text={option.label} />
            ))}
          </ComboBox>
          <Label>Kabuuang Laki ng Palaisdaan (Hectars)</Label>
          <Input
            placeholder="Enter size in hectares"
            value={entry.size || ""}
            onInput={(e) => handleInputChange(setFisheriesEntries, index, "size", e.target.value.toUpperCase())}
            style={{ textTransform: "uppercase" }}
          />
          <Label>Bilang ng Pitak o Units ng Palaisdaan</Label>
          <Input
            placeholder="Enter number of units"
            value={entry.units || ""}
            onInput={(e) => handleInputChange(setFisheriesEntries, index, "units", e.target.value.toUpperCase())}
            style={{ textTransform: "uppercase" }}
          />
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "1rem" }}>
            <div>
              <Label>Province</Label>
              <select
                value={entry.province || ""}
                onChange={(e) => {
                  const provinceId = e.target.value;
                  handleInputChange(setFisheriesEntries, index, "province", provinceId);
                  handleInputChange(setFisheriesEntries, index, "municipality", "");
                  handleInputChange(setFisheriesEntries, index, "barangay", "");
                  fetchMunicipalitiesForFisheries(provinceId, index);
                }}
                style={{ width: "100%", padding: "0.5rem" }}
              >
                <option value="">Select Province</option>
                {provinces.map((province) => (
                  <option key={province.province_id} value={province.province_id}>
                    {province.province_name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <Label>City/Municipality</Label>
              <select
                value={entry.municipality || ""}
                onChange={(e) => {
                  const municipalityId = e.target.value;
                  handleInputChange(setFisheriesEntries, index, "municipality", municipalityId);
                  handleInputChange(setFisheriesEntries, index, "barangay", "");
                  fetchBarangaysForFisheries(municipalityId, index);
                }}
                disabled={!entry.province}
                style={{ width: "100%", padding: "0.5rem" }}
              >
                <option value="">{entry.municipalityName || "Select City/Municipality"}</option>
                {(entry.municipalities || []).map((municipality) => (
                  <option key={municipality.municipality_id} value={municipality.municipality_id}>
                    {municipality.municipality_name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <Label>Barangay</Label>
              <select
                value={entry.barangay || ""}
                onChange={(e) => handleInputChange(setFisheriesEntries, index, "barangay", e.target.value)}
                disabled={!entry.municipality}
                style={{ width: "100%", padding: "0.5rem" }}
              >
                <option value="">{entry.barangayName || "Select Barangay"}</option>
                {(entry.barangays || []).map((barangay) => (
                  <option key={barangay.barangay_id} value={barangay.barangay_id}>
                    {barangay.barangay_name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <Button design="Negative" onClick={() => handleDeleteEntry(setFisheriesEntries, index)}>
            Delete Entry
          </Button>
        </FlexBox>
      ))}
      <Button design="Emphasized" onClick={() => handleAddEntry(setFisheriesEntries, 'fisheries')}>
        Add Entry
      </Button>
    </div>
  );
};

export default SocioeconomicForm6;